import Skeleton from "../../components/Skeleton/Skeleton";

const ListingNewsSkeleton = ({ height, width }) => {
    return (
        <div className='d-flex f-column jcc '>
            <Skeleton
                height={height}
                width={width}
            />
            <Skeleton
                className="mt-12"
                width="88px"
                height="12px"
            />
        </div>
    );
}
export default ListingNewsSkeleton ;
